import IBean from './IBean'

export default class gmlBean extends IBean {
    /**
     * @constructor
     * @param {File} file
     */
    constructor(file) {
        super()
        this.file = file
    }

    get FormData() {
        const data = new FormData()

        // name
        const fileName = this.file.name.slice(
            0,
            this.file.name.lastIndexOf('.')
        )
        // type
        const fileType = this.file.name.slice(
            this.file.name.lastIndexOf('.') + 1
        )

        data.append('file', this.file)
        data.append('fileName', fileName)
        data.append('fileType', fileType)
        return data
    }
}
